'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ImagesEntityOrAttachmentsEntityOrImage } from '@eliadmin/core/src/api/products/types/product-types';
import { MdOutlineFileDownload } from 'react-icons/md';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const ProductDownloadAttachment = ({
  attachments,
}: {
  attachments: ImagesEntityOrAttachmentsEntityOrImage[];
}) => {
  const { t } = useTranslations();

  async function downloadSheet(sheetUrl: string) {
    try {
      const response = await fetch(sheetUrl);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', sheetUrl.split('/').pop() || 'download.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading the sheet:', error);
    }
  }

  const handleDownloadClick = ({ file }: { file: { url: string } }) => {
    if (file?.url) {
      downloadSheet(file.url);
    }
  };

  return (
    <>
      {attachments.map(attachment => (
        <div
          key={attachment.name}
          className="flex w-full items-center justify-between gap-3 bg-[#F6F6F6] px-6 py-3"
        >
          <div className="flex items-center justify-start gap-3">
            <Image src={'/images/pdf-file.svg'} alt={attachment.name} width={20} height={24} />
            <p className="text-sm font-semibold text-foreground">{attachment.name}</p>
          </div>
          <span
            onClick={() => handleDownloadClick({ file: { url: attachment.url } })}
            className="flex cursor-pointer items-center justify-end gap-2 text-sm font-semibold text-primary"
          >
            <MdOutlineFileDownload size={24} />
            {t('text717')}
          </span>
        </div>
      ))}
    </>
  );
};
